const $ = jQuery.noConflict();

'use strict';
const FormValidation = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.onlyNumberAlowed();
		this.passwordField();
		$('.js-submit-btn').on('click', function(event) {
			FormValidation.formValidation(event);
		});
		$('.js-listing-submit-btn').on('click', function(event) {
			FormValidation.formValidation(event);
		});
		$('.account-info-submit').on('click', function(event) {
			FormValidation.formValidation(event);
		});
		$('.js-buy-now_submit').on('click', function(event) {
			FormValidation.formValidation(event, 'auction_form-buy-now');
		});
		this.switchRequiredFieldsListingType();
	},

	formValidation: function(event, currentForm = '') {
		let searchedForm = '';
		let fileHolder = '';
		if(currentForm){
			searchedForm = $('.' + currentForm + ' .js-input--required');
			fileHolder = $('.' + currentForm + ' .js-file-list');
		} else {
			searchedForm = $('.js-input--required');
			fileHolder = $('.js-file-list');
		}
		searchedForm.each(function() {
			const inputField = $(this).find('input').not(':disabled');
			const errorText = $(this).find('.error-message');
			const type = inputField.attr('type');
			const inputName = inputField.attr('name');
			const inputValue = inputField.val();

			if (type === 'checkbox') {
				if (!inputField.prop('checked')) {
					handleError(inputField, errorText, 'Field is required');
				} else {
					handleSuccess(inputField, errorText);
				}
			} else if (type === 'email') {
				if (inputValue === '') {
					handleError(inputField, errorText, 'Field is required');
				} else if (!isValidEmail(inputValue)) {
					handleError(inputField, errorText, 'Invalid email address');
				} else {
					handleSuccess(inputField, errorText);
				}
			} else if (inputName === 'password') {
				if (inputValue === '') {
					handleError(inputField, errorText, 'Field is required');
				} else if (!isValidPassword(inputValue)) {
					handleError(inputField, errorText, 'Password must be at least 8 characters long and include at least one uppercase letter and one number.');
				} else {
					handleSuccess(inputField, errorText);
				}
			} else {
				if (inputValue === '') {
					handleError(inputField, errorText, 'Field is required');
				} else {
					handleSuccess(inputField, errorText);
				}
			}
			if(fileHolder.length > 0 && fileHolder.find('li').length === 0) {
				const fileInput = $('.js-custom-file').find('input');
				const fileErrorText = fileInput.siblings('.error-message');
				if (fileErrorText.length === 0) {
					handleError(fileInput, fileErrorText, 'Field is required');
				}
			} else if(fileHolder.length > 0) {
				const fileInput = $('.js-custom-file').find('input');
				const fileErrorText = fileInput.siblings('.error-message');
				handleSuccess(fileInput, fileErrorText);
			}
		});

		if ($('.error-message').length > 0) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: $('.error-message').filter(':visible').first().offset().top - 180
			}, 'slow');
		} else {
			$('.submit-listing-form').addClass('overlay-submit');
		}

		// Add event listeners for input event to clear error messages
		$('.js-input--required input').on('input', function() {
			const inputField = $(this);
			const errorText = inputField.siblings('.error-message');
			handleSuccess(inputField, errorText);
		});

		function handleError(inputField, errorText, errorMessage) {
			inputField.addClass('error');
			inputField.parent().addClass('error-input');
			if (errorText.length === 0) {
				inputField.parent().append('<span class="error-message">' + errorMessage + '</span>');
			} else {
				errorText.text(errorMessage);
			}

			// Only show the error if the field is visible
			if (inputField.closest(':visible').length === 0) {
				errorText.css('visibility', 'hidden');
			} else {
				errorText.css('visibility', 'visible');
			}
		}

		function handleSuccess(inputField, errorText) {
			inputField.removeClass('error');
			inputField.parent().removeClass('error-input');
			errorText.remove();
		}

		function isValidEmail(email) {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return emailRegex.test(email);
		}

		function isValidPassword(password) {
			const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/;
			return passwordRegex.test(password);
		}
	},

	onlyNumberAlowed: () => {
		$('input[type="number"]').on('input', function() {
			let inputValue = $(this).val();
			inputValue = inputValue.replace(/[^\d]/g, '');
			$(this).val(inputValue);
		});
	},

	passwordField: () => {
		const hideIcon = $('.js-input-pass-hide');
		const showIcon = $('.js-input-pass-show');

		hideIcon.on('click', function() {
			$(this).parent().find('input').attr('type', 'text');
			$(this).parent().find('.js-input-pass-hide').hide();
			$(this).parent().find('.js-input-pass-show').show();
		});

		showIcon.on('click', function() {
			$(this).parent().find('input').attr('type', 'password');
			$(this).parent().find('.js-input-pass-hide').show();
			$(this).parent().find('.js-input-pass-show').hide();
		});
	},

	switchRequiredFieldsListingType: () => {
		let flag = false;
		const wrapper = $('.js-form-listing-type-wrapper');
		const switchItem = $('.js-account-block__switch-bar');

		switchItem.on('click', function() {
			flag = !flag;

			if(flag) {
				wrapper.hide();
				wrapper.find('input, select, textarea').prop('disabled', true);
			} else {
				wrapper.show();
				wrapper.find('input, select, textarea').prop('disabled', false);
			}
		});

		//reset switch after form is submitted succesfully
		$('.submit-listing-form__form').submit(function(e) {
			e.preventDefault();

			wrapper.find(':hidden').prop('disabled', true);

			$.ajax({
				url: window.fwsLocalized.ajaxUrl,
				type: 'POST',
				data: {
					action: 'create_auction_review',
					formData: $(this).serialize(),
				},
				success: function(response) {
					setTimeout(() => {
						flag = false;
						wrapper.show();
						wrapper.find('input, select, textarea').prop('disabled', false);
						wrapper.find('input, select, textarea').removeClass('error');
					}, 1000);
				},
				error: function(xhr, status, error) {
					console.error('AJAX Request Failed: ', status, error);
				},
			});
		});
	}
};

export default FormValidation;
